import { Image, Skeleton } from "@mantine/core";
import Autoplay from "embla-carousel-autoplay";
import { useRef } from "react";
import Carousel from "../../components/carousel";
import useShowcase from "../../hooks/useShowcase";

/**
 * As ms
 */
const CAROUSEL_DELAY = 2000;

export default function MainPageCarousel() {
  const { data: showcaseData, isLoading } = useShowcase().useGetAll();
  // console.log(showcaseData);
  const autoplay = useRef(Autoplay({ delay: CAROUSEL_DELAY }));

  return (
    <div className="main-page-carousel flex flex-col gap-4">
      <Carousel
        height={260}
        loop
        withControls
        align={`start`}
        plugins={[autoplay.current]}
        onMouseEnter={autoplay.current.stop}
        onMouseLeave={autoplay.current.reset}
      >
        {showcaseData ? (
          showcaseData.map((showcaseItem) => {
            return (
              <Carousel.Slide key={showcaseItem.id}>
                <Image
                  src={showcaseItem.url}
                  h={"100%"}
                  className="object-fit"
                />
              </Carousel.Slide>
            );
          })
        ) : (
          <Carousel.Slide>
            <Skeleton h={1080} w={1920} />
          </Carousel.Slide>
        )}
      </Carousel>
    </div>
  );
}
